import { Navigate, Outlet } from "react-router-dom";
import { useAuth } from "../context/AuthContext";
import { useEffect, useState } from "react";
import axios from "axios";
import { Box, CircularProgress } from "@mui/material";

export const EmailVerifiedRoute = ({ routeId }) => {
  const { user } = useAuth();
  const [config, setConfig] = useState(null);

  useEffect(() => {
    const loadConfig = async () => {
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API_URL}/api/route-access/${routeId}`
        );
        setConfig(data);
      } catch (err) {
        console.error("Error cargando permisos", err);
        setConfig({ blocked: false });
      }
    };

    loadConfig();
  }, [routeId]);

  if (!config) {
    return (
      <Box sx={{ display: "flex", justifyContent: "center", mt: 5 }}>
        <CircularProgress />
      </Box>
    );
  }

  // 🔴 bloqueo dinámico
  // if (
  //   config.blocked &&
  //   config.requireVerifiedEmail &&
  //   !user?.isEmailVerified
  // ) {
  //   return <Navigate to="/panel/profile" replace />;
  // }

  return <Outlet />;
};
